import { Separator as Primitive } from "radix-ui";
import { cn } from "../../../cn.ts";

/**
 * § Primitives, Separator: a one-pixel divider, decorative unless it separates content for assistive
 * technology. Taken from shadcn/ui's Separator (new-york-v4, MIT) and themed through the variables of
 * `packages/tokens` (2026-09-15, slice (e)); the line is the subtle border and the border width,
 * where the source draws the default border at 1 px, and a vertical line stretches to its row.
 */
export interface SeparatorProps {
  readonly orientation?: "horizontal" | "vertical";
  readonly decorative?: boolean;
  readonly className?: string;
}

export function Separator({ orientation = "horizontal", decorative = true, className }: SeparatorProps) {
  return (
    <Primitive.Root
      data-slot="separator"
      orientation={orientation}
      decorative={decorative}
      className={cn("shrink-0 bg-border-subtle data-[orientation=horizontal]:h-(--border-width) data-[orientation=horizontal]:w-full data-[orientation=vertical]:w-(--border-width) data-[orientation=vertical]:self-stretch", className)}
    />
  );
}
